import { useFormContext } from "react-hook-form";
import InputText from "../../components/InputText";
import PriceInput from "../../components/PriceInput";
// import { CONTRACT_RECORD_TYPE } from "../../constant";
import DatePicker from "../../components/DatePicker";
import SelectField from "../../components/SelectField";
import { RootState } from "../../store/root-reducer";
import { connect, useDispatch } from "react-redux";
import { getSKUOptions } from "../../store/user/actions";
import { useEffect } from "react";
import Loader from "../../components/Loader";
import { UserScope } from "../../store/user/types";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import moment from "moment";

interface AssociatedDealer {
  id: string;
  alias: string;
}

function PurchaseInformation({
  skus,
  loading,
  associated_dealers,
}: {
  skus: any[];
  loading: boolean;
  associated_dealers: AssociatedDealer[];
}) {
  const { control, setValue, watch } = useFormContext();
  const dispatch = useDispatch();
  const dealer_id = watch("dealer_id");
  const delivery_date = watch("delivery_date");
  const protectall_sku = watch("protectall_sku");

  // Set dealer_id for single dealer accounts
  useEffect(() => {
    if (associated_dealers.length === 1 && !dealer_id) {
      setValue("dealer_id", associated_dealers[0]?.id);
    }
  }, [associated_dealers, dealer_id, setValue]);

  useEffect(() => {
    const currentDealerId =
      dealer_id?.value || dealer_id || associated_dealers[0]?.id;
    if (currentDealerId) {
      dispatch(
        getSKUOptions({
          deliveryDate: moment(delivery_date).format("MM-DD-YYYY"),
          dealerId: currentDealerId,
        })
      );
    }
  }, [delivery_date, dispatch, dealer_id, associated_dealers]);

  useEffect(() => {
    if (!loading && protectall_sku) {
      const skuValue = protectall_sku?.value || protectall_sku;
      const isStillAvailable = skus.some((item) => item.planType === skuValue);
      if (!isStillAvailable) {
        setValue("protectall_sku", null);
      }
    }
  }, [skus, loading, protectall_sku, setValue]);

  return (
    <div className="max-w-[700px] w-full mx-auto grid gap-y-10">
      <Loader isLoading={loading} />
      <div className="grid gap-y-3">
        {associated_dealers.length > 1 && (
          <SelectField
            control={control as any}
            name="dealer_id"
            label="Select Associated Dealer"
            placeholder="Select Associated Dealer"
            options={associated_dealers.map((d) => ({
              label: d.alias,
              value: d.id,
            }))}
            defaultValue={{
              label: associated_dealers[0].alias,
              value: associated_dealers[0].id,
            }}
            required
          />
        )}
        <InputText
          name="invoice_number"
          control={control}
          type="text"
          label="Invoice Number"
          required
        />
        <SelectField
          control={control}
          name="protectall_sku"
          label="Protection Plan SKU"
          required
          isSearchable
          isClearable
          placeholder="Plan Type (SKU)"
          options={skus.map((item) => ({
            label: `${item.planType} (${item.sku})`,
            value: item.planType,
          }))}
        />
        {/* <InputText
          control={control}
          name="protectall_sku"
          type="text"
          label="Nikon Care SKU"
          required
        /> */}
        {/* <InputText
          control={control}
          name="dealer_sku"
          type="text"
          label="Dealer SKU"
        /> 
         <InputText
          control={control}
          name="dealer_contract_number"
          type="text"
          label="Dealer Contract Number"
        /> */}
        <InputText
          name="reference_number"
          control={control}
          type="text"
          label="Reference Number"
        />
        {/* <SelectField
          name="record_type"
          control={control}
          defaultValue={CONTRACT_RECORD_TYPE[0]}
          label="Record Type"
          options={CONTRACT_RECORD_TYPE}
          required
        /> */}
        <DatePicker
          control={control}
          name="contract_purchase_date"
          label="Contract Purchase Date"
          defaultValue={new Date()}
          required
        />
        <DatePicker
          control={control}
          name="delivery_date"
          label="Contract Delivery Date"
          defaultValue={new Date()}
          // onChange={(selectedDate) => {
          //   if (dealer_id) {
          //     dispatch(
          //       getSKUOptions({
          //         deliveryDate: moment(selectedDate).format("MM-DD-YYYY"),
          //         dealerId: dealer_id,
          //       })
          //     );
          //   }
          // }}
        />
        <PriceInput
          control={control}
          name="contract_retail_price"
          label="Contract Retail Price"
          required
        />
        <PriceInput
          control={control}
          name="total_product_retail_value"
          label="Total Product Retail Value"
          required
        />
      </div>
    </div>
  );
}

const mapStateProps = (state: RootState) => {
  return {
    skus: state.user.skus || [],
    loading: isScopeLoading(state.scopeLoading, `${UserScope}-skus`),
    associated_dealers: state.user.selectedOrg.associated_dealers || [],
  };
};

export default connect(mapStateProps)(PurchaseInformation);
